// 记录当前发起 AI 抽取的 Job Detail 页组件引用。
// 全局抽屉（挂在 MainApp）写回成功后，靠它刷新该页的 JobContact / Document / 属性等 section。
// 用模块单例而非塞进 Redux —— React 组件实例不可序列化，不适合放 store。
let activePage = null;

export const setAiActivePage = (page) => { activePage = page; };
export const getAiActivePage = () => activePage;
